import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  accessActions,
  attendanceActions,
  authActions,
  userActions
} from "../../redux/actions";
import TopRightUser from "./TopRightUser";

const TopBar = ({ title }) => {
  const dispatch = useDispatch();
  const onLogoutPress = () => {
    dispatch(userActions.unmountAllUsersData());
    dispatch(attendanceActions.unmountAttendanceData());
    dispatch(authActions.logoutUser());
  };

  const onChangeModule = () => {
    dispatch(accessActions.changeAccess());
  };

  const { currentUser } = useSelector((state) => state.auth);
  return (
    <div
      className="navbar-custom mb-3"
      style={{
        background:
          "linear-gradient(to top, rgba(255,255,255,0.10) 0%, rgba(0,0,0,0.5) 100%), radial-gradient(at top center, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.40) 120%) #989898"
      }}
    >
      <ul className="list-unstyled Topbar-right-menu float-right mb-0">
        <TopRightUser
          userInfo={currentUser || {}}
          onLogoutPress={onLogoutPress}
          onChangeModule={onChangeModule}
        />
      </ul>
      <div className="app-search">
        <h4 className="page-title ml-2 text-white"> {title}</h4>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  title: PropTypes.string.isRequired
};

export default TopBar;
